// This file is overwritten in development to use local version of redux-crud-factory

// @ts-ignore
import reduxCrudFactory from 'redux-crud-factory';

export default reduxCrudFactory;
